
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M22 18h5.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-.25v8a.5.5 0 0 1-.5.5H5.25a.5.5 0 0 1-.5-.5v-8H4.5A.5.5 0 0 1 4 19v-.5a.5.5 0 0 1 .5-.5H10V5.743A1.672 1.672 0 0 1 11.632 4h8.736A1.672 1.672 0 0 1 22 5.743V18Zm-5.25 8.5h3.75v-7h-3.75v7Zm-1.5 0v-7H11.5v7h3.75Zm-3.618-21c-.073 0-.132.109-.132.243V18h9V5.743c0-.134-.06-.243-.132-.243h-8.736ZM10 19.5H6.25v7H10v-7Zm12 7h3.75v-7H22v7ZM13.5 15h1a.75.75 0 1 1 0 1.5h-1a.75.75 0 1 1 0-1.5Z"}})])
          )
        }
      }
    